import { render, staticRenderFns } from "./AccidentIntakeTestsImagingForm.vue?vue&type=template&id=e5932f68&scoped=true"
import script from "./AccidentIntakeTestsImagingForm.vue?vue&type=script&lang=js"
export * from "./AccidentIntakeTestsImagingForm.vue?vue&type=script&lang=js"
import style0 from "./AccidentIntakeTestsImagingForm.vue?vue&type=style&index=0&id=e5932f68&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5932f68",
  null
  
)

export default component.exports